import { Col, Row } from 'react-bootstrap';
import styles from './styles.module.scss';
import { Btn } from '../Btn';
import { IoReloadSharp } from 'react-icons/io5';
interface ILayoutFilter {
  children: any;
  title: string;
  onClickAdd?: () => void;
  onClickClear?: () => void;
  onClickSearch?: any;
  onClickAddAlternative?: () => void;
  altBtnText?: string;
  textAdd?: string;
  onClickOpenFilter?: any;
  openFilter?: boolean;
  isLoading?: boolean;
  hasSearchButton?: boolean;
  showReloadButton?: boolean;
  extraActions?: React.ReactNode;
}

export default function LayoutFilter({
  children,
  title,
  onClickAdd,
  onClickClear,
  onClickSearch,
  textAdd,
  altBtnText,
  onClickAddAlternative,
  onClickOpenFilter,
  openFilter,
  isLoading,
  hasSearchButton = true,
  showReloadButton = false, // ✅ Valor padrão
  extraActions,
}: ILayoutFilter) {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.container}>
      <Row>
        <Col className={styles.titleGroup}>
          <h3>{title}</h3>
          <div style={{ display: 'flex', gap: '1rem' }}>
            {onClickOpenFilter && (
              <div className={styles.btnFilter}>
                <Btn
                  text="Clique para filtrar"
                  type="button"
                  variante="info"
                  icon={'arrow'}
                  onClick={onClickOpenFilter}
                />
              </div>
            )}
            {onClickAddAlternative && (
              <Btn
                text={altBtnText ? altBtnText : ''}
                type="button"
                variante="info"
                icon={'plus'}
                onClick={onClickAddAlternative}
              />
            )}
            {extraActions}
            {onClickAdd && (
              <Btn
                text={textAdd ? textAdd : 'Adicionar'}
                type="button"
                variante="primary"
                icon={'plus'}
                onClick={onClickAdd}
                disable={isLoading}
              />
            )}
            {showReloadButton && (
              <Btn
                text=""
                type="button"
                variante="warning"
                onClick={handleReload}
                icon="refresh"
              />
            )}
          </div>
        </Col>
      </Row>
      <div className="mt-2" />
      {children}
      {onClickClear && onClickSearch && (
        <Row className="mt-2">
          <Col className={styles.btnGourp}>
            <div className={styles.btn}>
              <Btn
                text="Limpar"
                type="button"
                variante="secondary"
                icon="trash"
                onClick={onClickClear}
              />
              {hasSearchButton && (
                <Btn
                  text="Buscar"
                  type={'button'}
                  variante="success"
                  icon="search"
                  onClick={onClickSearch}
                />
              )}
            </div>
            {openFilter && (
              <div className={styles.btnMin}>
                {hasSearchButton && (
                  <Btn
                    text="Limpar"
                    type="button"
                    variante="secondary"
                    icon="trash"
                    onClick={onClickClear}
                  />
                )}
                <Btn
                  text="Buscar"
                  type={'button'}
                  variante="success"
                  icon="search"
                  onClick={onClickSearch}
                />
              </div>
            )}
          </Col>
        </Row>
      )}
    </div>
  );
}
